import { Uuid } from '@ftr/contracts/type/shared'
import { JUDGE_ROLES_ACTION_SCOPE } from './judge-roles.commands'

export class JudgeRolesListAccessForbidden {
  static readonly type = `${JUDGE_ROLES_ACTION_SCOPE} Upcoming Hearings List Access Forbidden`
  constructor(readonly courtSystemId: Uuid) {}
}
